import { createAction } from 'redux-actions';
import * as types from './info-constants';

export const getEquipmentInfoRequest = createAction(types.GET_EQUIPMENT_INFO_REQUEST);
export const getEquipmentInfoSuccess = createAction(types.GET_EQUIPMENT_INFO_SUCCESS);
export const getEquipmentInfoFailure = createAction(types.GET_EQUIPMENT_INFO_FAILURE);

export const saveEquipmentInfoRequest = createAction(types.SAVE_EQUIPMENT_INFO_REQUEST);
export const saveEquipmentInfoSuccess = createAction(types.SAVE_EQUIPMENT_INFO_SUCCESS);
export const saveEquipmentInfoFailure = createAction(types.SAVE_EQUIPMENT_INFO_FAILURE);

export const resetSaveSuccess = createAction(types.RESET_SAVE_SUCCESS);

export const fetchConnectionStatus = createAction(types.CONNECTION_STATUS_REQUEST);
export const fetchConnectionStatusSuccess = createAction(types.CONNECTION_STATUS_SUCCESS);
export const fetchConnectionStatusFailure = createAction(types.CONNECTION_STATUS_FAILURE);
